import { render, staticRenderFns } from "./contact_index.vue?vue&type=template&id=0499b983&lang=html&"
import script from "./contact_index.vue?vue&type=script&lang=js&"
export * from "./contact_index.vue?vue&type=script&lang=js&"
import style0 from "./contact_index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports